<template>
  <div class="group-box">
    <div class="top-title" :class="{hide: !showTitle}">
      <i class="el-icon-bell"></i><span>{{ title | showTitle}}</span>
    </div>
    <div class="content-box">
      <!-- 为了main window单独处理 -->
      <div v-if="modeKey === 'mainWindow'">
        <ul class="pip scrollbar" >
          <li class="clearfix mainWindow">
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="$t('coordinationRoom.onAirEnabled')"
              placement="top">
              <div class="onAirText"  v-show="!muteAudioObj[userInfo.rtilCode] && onAirObj[userInfo.rtilCode] && !talkbackInfo[userInfo.rtilCode]">{{$t('coordinationRoom.onAir')}}</div>
            </el-tooltip> -->
            <slot></slot>
            <div class="metaData" v-show="showNetWorkParams">
              <p><span>channelId - {{ channels.channel }}</span></p>
              <p><span>uid - {{channels.id}}</span></p>
              <p><span>timeCode - {{ metaDataTimeCode? metaDataTimeCode : false }}</span></p>
              <p><span>sei timeCode - </span><span>{{ seiInfo ? seiInfo.timeCode : 0 }}</span></p>
              <P><span>timeCode difference(time - sei time) - {{ metaDataTimeCode && seiInfo ? metaDataTimeCode - seiInfo.timeCode : 0 }}</span></P>
              <p><span>R timeStamp - {{ metaDateTimeStamp }}</span></p>
              <p><span>web timeStamp - {{ webDateTimeStamp }}</span></p>
              <p><span>sei timeStamp - {{ seiInfo ? getFullTimestamp(seiInfo.timestamp) : 0 }}</span></p>
              <p><span>time difference - {{ metaDateTimeStamp ? new Date(webDateTimeStamp) - new Date(metaDateTimeStamp + '') : '' }}</span></p>
              <p><span>time difference(current - sei) - {{ seiInfo ? Date.now() - seiInfo.timestamp : 0 }}</span></p>
              <p><span>receiveFrameRate - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].receiveFrameRate}} (fps)</span></p>
              <p><span>receiveBitrate - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].receiveBitrate }} (bps)</span></p>
              <p><span>end2EndDelay - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].end2EndDelay }} (ms)</span></p>
              <p><span>freezeRate - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].freezeRate }} (Value range[0.0,1.0])</span></p>
              <p><span>currentPacketLossRate - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].currentPacketLossRate }}</span></p>
              <p><span>packetLossRate - {{ remoteVideoParams[channels.id] && remoteVideoParams[channels.id].packetLossRate }}</span></p>
            </div>
            <div class="box" ref="group-video-box">
              <AttendUser
                ref="attendUser"
                :rtc="rtc"
                :onAir="onAirObj[userInfo.rtilCode]&& !talkbackInfo[userInfo.rtilCode]"
                :muteAudio="muteAudioObj[userInfo.rtilCode] || muteAudioSelf"
                :isTalkBack="talkbackInfo[userInfo.rtilCode]"
                :coordRoomStatus="false"
                :remoteNetWorks="remoteNetWork[channels.id]"
                :showOperateBox="false"
                :title="channels.id + ''"
                :singChannel="channels"
                :pgmMute="pgmMute"
                :userInfo="userInfo"
                :userNewFullScreen="userNewFullScreen"
                :operateList="operation"
                @callback="attendCallback"
                :nickName="nickNameInfo[channels.id]"
                :volume="voiceList[channels.id] || {}"
                :modeKey="modeKey"
                @showNetWorkParams="showNetWorkParams= !showNetWorkParams"
              >
                <div class="defaultText" v-if="!channels.id">
                  <p v-if="eventStartTime===0">
                  {{$t('coordinationParticipant.gettingReady')}}
                  </p>
                  <p v-else>
                  {{$t('coordinationParticipant.theEventTimeIs')}} {{ eventStartTime }} - {{ eventEndTime }}
                  </p>
                </div>
              </AttendUser>
            </div>
            <Volume :rtilCode="channels.id" :height="volumeHeight"></Volume>
          </li>
        </ul>
      </div>
      <ul class="pip scrollbar pipList" v-else>
        <li class="clearfix" v-if="!modeKey">
          <div class="pip-title" :class="{hide: !showTitle}">{{ nickNameInfo[meInfo.id] }}</div>
          <div class="pipParams" v-show="localParams" @click="localParams = !localParams">
            <p><span>frameRate - {{ localVidoeParams.localCaptureFrameRate }} (fps)</span></p>
            <p><span>resolutionH - {{localVidoeParams.localCaptureResolutionHeight}}</span></p>
            <p><span>resolutionW - {{localVidoeParams.localCaptureResolutionWidth}}</span></p>
          </div>
          <div class="box" ref="group-video-box">
            <AttendUser
              class="is-local"
              title="Me"
              :privateInfo="privateInfo[userInfo.rtilCode]"
              :nickName="nickNameInfo[meInfo.id]"
              :singChannel="meInfo"
              :rtc="rtc"
              :volume="voiceList[userInfo.rtilCode] || {}"
              :userInfo="userInfo"
              :userNewFullScreen="userNewFullScreen"
              :isTalkback=talkbackInfo[meInfo.id]
              :talkBackType=talkbackType[meInfo.id]
              :isMemeberPrivate=isMemeberPrivate[meInfo.id]
              :video="videoObj[meInfo.id] || videoSelf"
              :muteAudio="muteAudioObj[meInfo.id] || muteAudioSelf"
              :operateList="operation"
              :showMuteIcons="false"
              :isPip="true"
              :isPrivate="isPrivate"
              @callback="attendCallback"
            >
              <div class="streamBox" id="local_stream" @dblclick="showOffSetBtn()"  @click="handleVideoClick"></div>
            </AttendUser>
          </div>
          <Volume :rtilCode="userInfo.rtilCode" :height="volumeHeight"></Volume>
        </li>
        <li v-for="val in channels" :key="val.id" class="clearfix" v-if="val.id">
          <div class="pip-title" :class="{hide: !showTitle}">{{ nickNameInfo[val.id] }}</div>
          <div class="pipParams" v-show="showRemotePipParams[val.id]" @click="showRemotePipParams[val.id] = !showRemotePipParams[val.id]">
            <p><span>frameRate - {{ remoteVideoParams[val.id] && remoteVideoParams[val.id].receiveFrameRate }} (fps)</span></p>
            <p><span>resolutionH - {{remoteVideoParams[val.id] && remoteVideoParams[val.id].receiveResolutionHeight}}</span></p>
            <p><span>resolutionW - {{remoteVideoParams[val.id] && remoteVideoParams[val.id].receiveResolutionWidth}}</span></p>
          </div>
          <div class="box">
            <AttendUser
              :ref="`attender${val.id}`"
              :rtc="rtc"
              :remoteNetWorks="remoteNetWork[val.id]"
              :privateInfo="privateInfo[val.id]"
              :title="val.id + ''"
              :nickName="nickNameInfo[val.id]"
              :singChannel="val"
              :userInfo="userInfo"
              :video="videoObj[val.id]"
              :muteAudio="muteAudioObj[val.id]"
              :volume="voiceList[val.id] || {}"
              :operateList="operation"
              :userNewFullScreen="userNewFullScreen"
              :isMemeberPrivate=isMemeberPrivate[val.id]
              :isTalkback=talkbackInfo[val.id]
              :talkBackType=talkbackType[val.id]
              :isPrivate="isPrivate"
              :isPip="true"
              @callback="attendCallback"
              @showNetWorkParams="showRemotePip"
            >
            </AttendUser>
          </div>
          <Volume :rtilCode="val.id" :height="volumeHeight"></Volume>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import AttendUser from '@/components/common/attendUser'
import Volume from '@/components/common/volume.vue'
import { mapState } from 'vuex'
import i18n from '@/lang/index.js'
import Bus from '@/assets/js/bus.js'
import { updateAmSourceName, formatNumberWithLocale } from '@/assets/js/utils.js'

const moment = require('moment')
export default {
  components: {
    AttendUser,
    Volume
  },
  props: {
    metaDataTimeCode: [String, Number],
    metaDateTimeStamp: [String, Number],
    seiInfo: Object,
    privateInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isMemeberPrivate: {
      type: Object,
      default: function () {
        return {}
      }
    },
    title: String,
    modeKey: String,
    videoSelf: Boolean,
    muteAudioSelf: Boolean,
    rtc: {
      type: Object,
      default: function () {
        return {}
      }
    },
    meInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    channels: {
      type: Object,
      default: function () {
        return {}
      }
    },
    videoObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
    allPairStatusInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    amStatusInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    muteAudioObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
    voiceList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
    nickNameInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    userNewFullScreen: {
      type: Boolean,
      default: false
    },
    pgmMute: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      eventInfo: (state) => state.eventInfo,
      enableFeedback: (state) => state.enableFeedback
    })
  },
  watch: {
    eventInfo (info) {
      const { startTime, endTime } = info
      this.eventStartTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
      this.eventEndTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
    },
    metaDateTimeStamp (val) {
      if (val) {
        this.webDateTimeStamp = this.getFullTimestamp(new Date().getTime())
      }
    },
    enableFeedback (val) {
      if (this.title === 'Talent Commentator' && val && !this.muteAudioObj[this.meInfo.id] && this.rtc?._localAudioTrack) {
        this.rtc._localAudioTrack.play()
      } else {
        this.rtc?._localAudioTrack?.stop()
      }
    }
  },
  data () {
    return {
      lastTimestamp: 0,
      showRemotePipParams: {},
      localVidoeParams: {
        localCaptureFrameRate: '',
        localCaptureResolutionHeight: '',
        localCaptureResolutionWidth: ''
      },
      showOffSet: false,
      remoteVideoParams: {},
      singeleStatusInfo: {},
      onAirObj: {},
      remoteNetWork: {},
      showNetWorkParams: false,
      localParams: false,
      volumeHeight: 50,
      eventStartTime: 0,
      eventEndTime: 0,
      operation: [],
      talkbackInfo: {},
      talkbackType: {},
      webDateTimeStamp: ''
    }
  },
  async created () {
    Bus.$on('seLocalVideoParams', (payload) => {
      if (!payload.type || !payload.captureResolutionHeight || !payload.captureFrameRate || !payload.captureResolutionWidth) return
      this.localVidoeParams = {
        localCaptureFrameRate: formatNumberWithLocale(payload.captureFrameRate),
        localCaptureResolutionHeight: formatNumberWithLocale(payload.captureResolutionHeight),
        localCaptureResolutionWidth: formatNumberWithLocale(payload.captureResolutionWidth)
      }
    })
    Bus.$on('setMainWindowVideoParams', (payload) => {
      if (!payload.type) return
      this.$set(this.remoteVideoParams, payload.id, {
        id: payload.id,
        receiveFrameRate: formatNumberWithLocale(payload.receiveFrameRate),
        receiveResolutionHeight: formatNumberWithLocale(payload.receiveResolutionHeight),
        receiveResolutionWidth: formatNumberWithLocale(payload.receiveResolutionWidth),
        receiveBitrate: formatNumberWithLocale(payload.receiveBitrate),
        end2EndDelay: formatNumberWithLocale(payload.end2EndDelay),
        freezeRate: formatNumberWithLocale(payload.freezeRate),
        currentPacketLossRate: formatNumberWithLocale(payload.currentPacketLossRate),
        packetLossRate: formatNumberWithLocale(payload.packetLossRate)
      })
    })
    Bus.$on('setUnlinkQuality', (payload) => {
      if (!payload.type) return
      this.$set(this.remoteNetWork, payload.id, {
        id: payload.id,
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      })
    })
    window.addEventListener('resize', this.computedWidth)
    this.$nextTick(() => {
      this.computedWidth()
    })
    Bus.$on('GrapqQLDataChange', (vals) => {
      if (this.modeKey != 'mainWindow') return
      const val = vals.payload.data
      // 时间戳校验
      const timeStamp = val.onUpdatedPair.timestamp
      if (!this.lastTimestamp) {
        this.lastTimestamp = timeStamp
      } else if (timeStamp <= this.lastTimestamp) {
        // 新数据的时间戳小于等于上次的时间戳，丢弃老数据
        console.log(`收到AM旧数据，已丢弃，当前时间: ${timeStamp}，上次时间: ${this.lastTimestamp}`)
        return
      } else {
        this.lastTimestamp = timeStamp
      }
      const amStatusInfo = {}
      const newAmStatusInfo = {}
      // 单个pair的状态(ws推送更新的)
      val.onUpdatedPair.inputDatas?.filter(item =>
        item.ID?.includes('Commentator') && // 必须包含关键标识
    item.audioStreams?.length > 0 // 确保数组非空
      )
        .forEach((itemInput) => {
          const parts = itemInput.ID?.split('_') ?? []
          const rtilCode = parts[2]
          const channelDatas = itemInput.audioStreams?.[0]?.channelDatas ?? new Map()
          const hasoOutput = Array.from(channelDatas.values()).some(item => 'output' in item)
          if (!hasoOutput) return
          // 支持左右声道
          newAmStatusInfo[rtilCode] = { ...channelDatas }
          // rejoinR 记录是否在R上
          this.$set(this.amStatusInfo, rtilCode, newAmStatusInfo[rtilCode])
          // 记录更新的onAir状态
          this.$set(amStatusInfo, rtilCode, newAmStatusInfo[rtilCode])
          this.$set(this.singeleStatusInfo, val.onUpdatedPair.ID, amStatusInfo)
        })
      // talkBack相关消息不处理
      if (Object.keys(this.singeleStatusInfo).length == 0) return
      // 将ws的变化同步到初始化时候所有pair状态
      Object.keys(this.allPairStatusInfo).forEach((ID) => {
        // 改变当前pair的状态
        if (ID == val.onUpdatedPair.ID) {
          const subMap = this.allPairStatusInfo[ID]
          Object.keys(subMap).forEach((rtilCode) => {
            if (this.singeleStatusInfo[ID][rtilCode]) {
              subMap[rtilCode] = this.singeleStatusInfo[ID][rtilCode]
            }
          })
        }
      })
      this.dealStatus(false, val)
    })
    Bus.$on('setBehaviors', (v) => {
      const behaviors = v.behaviors
      behaviors.forEach((val) => {
        if ((val.key == 'callAll' || val.key == 'callHost' || val.key == 'callPip') && val.initiator == this.userInfo.realPartyCode) {
          this.$set(this.talkbackInfo, val.mark, val.value == 'true')
          this.$set(this.talkbackType, val.mark, val.key)
        }
        if (val.key == 'camera') {
          this.videoObj[val.mark] = val.value === 'true'
        }
      })
    })
  },
  methods: {
    // 本地视频质量数据显示
    handleVideoClick (event) {
      if (event.ctrlKey || event.metaKey) {
        this.localParams = !this.localParams
      }
    },
    showOffSetBtn () {
      this.showOffSet = !this.showOffSet
      this.$emit('callback', { type: 'showOffSetBtn', val: this.showOffSet })
    },
    // 处理onAir状态
    dealStatus (initStatus) {
      if (!initStatus) {
        if (this.amStatusInfo[this.userInfo.rtilCode]) {
          const updateParams = {
            partyCode: this.userInfo.realPartyCode,
            rtilCode: this.userInfo.rtilCode,
            rtilName: localStorage.getItem(`nickName_${this.partyCode}`), // 去掉首尾空格
            eventId: this.eventInfo.id,
            toRtilCode: this.userInfo.rtilCode
          }
          updateAmSourceName(updateParams)
        }
      }
      // onAir状态设置
      Object.values(this.allPairStatusInfo).forEach(subMap => {
        Object.keys(subMap).forEach(rtilCode => {
          this.$set(this.onAirObj, rtilCode, false)
        })
      })

      Object.values(this.allPairStatusInfo).forEach(subMap => {
        Object.keys(subMap).forEach(rtilCode => {
          // 左右声道0，1
          if ((subMap[rtilCode]?.[0]?.output && !subMap[rtilCode]?.[0]?.mute && !this.muteAudioObj[rtilCode]) ||
           (subMap[rtilCode]?.[1]?.output && !subMap[rtilCode]?.[1]?.mute && !this.muteAudioObj[rtilCode])) {
            this.$set(this.onAirObj, rtilCode, true)
          }
        })
      })
    },
    setSpeaker () {
      if (this.$refs.attendUser) {
        this.$refs.attendUser.setSpeakerAttendUser()
      }
    },
    getFullTimestamp (timeStamp) {
      if (!timeStamp) return ''
      const pad = (n, s = 2) => {
        const str = String(n)
        return str.padStart(s, '0')
      }
      const d = new Date(timeStamp)
      return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`
    },
    computedWidth () {
      setTimeout(() => {
        const height = this.$refs['group-video-box'] && this.$refs['group-video-box'].clientHeight
        this.volumeHeight = height
      }, 500)
    },
    showRemotePip (id, value) {
      this.$set(this.showRemotePipParams, id, value)
    },
    attendCallback ({ type, id, val, isControlMute }) {
      if (type === 'muteVideo' || type === 'muteAudio') {
        this.setOperate({ type, id, val, isControlMute })
      } else if (type === 'fullScreen') {
        this.$emit('callback', { type: 'fullscreen', val })
      }
    },
    setOperate ({ type, id, val, isControlMute }) {
      // 把 mute pgm 的操作存在本地 localstorage
      if (this.modeKey === 'mainWindow' && this.channels.id == id) {
        this.$emit('callback', { type: 'savePgmMute', val, isControlMute })
      }
      // mian window 和不是自己都不要控制
      if (this.modeKey || id != this.userInfo.rtilCode) return
      if (type === 'muteVideo') {
        // 先操作然后在改值
        this.videoSelf
          ? this.rtc.setEnabled(true, 'video')
          : this.rtc.setEnabled(false, 'video')
        this.$emit('callback', 'muteVideo')
      }
      if (type === 'muteAudio') {
        this.muteAudioSelf
          ? this.rtc.setEnabled(false, 'audio')
          : this.rtc.setEnabled(true, 'audio')
        this.$emit('callback', 'muteAudio')
      }
    }
  },
  filters: {
    showTitle (title) {
      if (!title) return ''
      if (title === 'Main window') {
        return i18n.t('coordinationRoom.mainWindow')
      } else if (title === 'Talent Commentator') {
        return i18n.t('coordinationParticipant.talentCommentator')
      } else {
        return title
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.computedWidth)
  }
}
</script>
<style lang="less" scoped>
.group-box {
  height: 100%;
  width: 40%;
  margin-right: 8px;
  .content-box {
    background: #1c1c20;
    height: calc(100% - 95px);
    padding: 20px 0;
  }
  .pip {
    height: calc(100% - 45px);
    overflow-y: auto;
    padding: 0 10px;
    .pip-title {
      color: #909090;
      margin-bottom: 5px;
    }
    li {
      margin-bottom: 15px;
      position: relative;
      .box {
        width: calc(100% - 55px);
        float: left;
      }
      .volumeBox {
        float: left;
        height: 100%;
      }
      .private {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: -14px;
        transform: translate(-50%, -50%);
        padding: 5px 8px;
        border-radius: 5px;
        background: #27272a;
        box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 50%);
        margin-top: 10px;
        &.active {
          background: #f6445a;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
        }
      }
      &.mainWindow {
        width: 92%;
        transform: translateX(6%);
        .onAirText {
          position: absolute;
          z-index: 11111;
          cursor:default;
          background: #F6445A;
          padding: 6px;
          border-radius: 4px;
          top: 8px;
          left:8px;
          font-size: 12px;
        }
      }
    }
  }
  .pipList {
    height: calc(100vh - 180px);
    overflow-y: auto;
  }
  .top-title {
    font-size: 18px;
    font-weight: bold;
    color: #f1f1f1;
    padding: 15px 0;
    i {
      color: #999;
      margin-right: 5px;
    }
  }
  .top-btn {
    text-align: center;
    margin-bottom: 20px;
    .el-button {
      width: 180px;
      height: 32px;
      background: #28282e;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      color: #f1f1f1;
      border: 1px solid #28282e;
      padding: 8px 20px;
      &.active {
        border: 1px solid #f6445a;
        background: #f6445a;
      }
    }
  }
  /deep/.streamBox {
    height: 100%;
    width: 100%;
  }
  .content {
    height: calc(100% - 75px);
    background: #28282e;
    padding: 10px;
  }
}
</style>
